import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import { setAdsPage } from './analytics/google-ads';
import { Layout } from './components/layout';
import { LandingPage } from './pages/landing';
import { NotFoundPage } from './pages/not-found';
import { RequestPage } from './pages/request';
import { StatusPage } from './pages/status';
import { VerifyPage } from './pages/verify';

const TITLES: [RegExp, string][] = [
  [/^\/request/, 'Request an audit'],
  [/^\/r\//, 'Your audit request'],
  [/^\/verify\//, 'Verify a badge'],
];

/** Each route gets its own document title, so a screen-reader user hears where
 *  they landed. A hash change (nav jump) keeps the page's title. */
function useDocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const match = TITLES.find(([re]) => re.test(pathname));
    document.title = match
      ? `${match[1]} — Floto Accessibility Services`
      : 'Floto Accessibility Services — Expert WCAG audits';
  }, [pathname]);
}

/** Google sees the current route, not only the landing page. */
function useAdsPage() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    setAdsPage(window.location.href);
  }, [pathname, search]);
}

/** On a route change (not a hash jump), start at the top. */
function useScrollReset() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
}

export default function App() {
  useDocumentTitle();
  useScrollReset();
  useAdsPage();
  return (
    <Layout>
      <Routes>
        <Route element={<LandingPage />} path="/" />
        <Route element={<RequestPage />} path="/request" />
        <Route element={<StatusPage />} path="/r/:token" />
        <Route element={<VerifyPage />} path="/verify/:badgeId" />
        <Route element={<NotFoundPage />} path="*" />
      </Routes>
    </Layout>
  );
}
